import React from 'react';
import {round2Decimal} from 'app/utils';
import I18n from 'app/i18n';

const GIFT_TYPES = {
    BONUS: 2,
    MONEY: 0,
    POINTS: 1
};

const getType = type => {
    switch (type) {
    case GIFT_TYPES.BONUS:
        return 'bonus';
    case GIFT_TYPES.MONEY:
        return 'money';
    case GIFT_TYPES.POINTS:
        return 'points';
    default:
        return '';
    }
};

const MoneyGift = props => {
    const amount = props.type_id === GIFT_TYPES.MONEY ? `$${round2Decimal(props.amount)}` : props.name?.replace(/[a-zA-Zа-яА-Я ]/gu, '');

    return <div className="gift-choose__item gift-choose__item--money">
        <div className="gift-choose__content">
            <div className="gift-choose__icon money">
                <img src={props.skin_gift_images.money} />
                <span>{amount}</span>
            </div>
            <div className="gift-choose__name">
                {I18n.t(`gifts.equivalent.${getType(props.type_id)}`)}
            </div>
        </div>
    </div>;
};

export default MoneyGift;
